<template>

  <b-nav small tabs class="pageTabs" v-if="!presentationMode" style="position: relative">

    <b-nav-item v-if="isLoginUserItemReadable(this.pageSensor)" :active="current=='grid'" title="센서에 저장된 데이터 그리드입니다." :to="'/s/' + pageSensor.id">
      표
    </b-nav-item>

    <b-nav-item v-if="isLoginUserItemReadable(this.pageSensor)" :active="current=='graph'" title="센서에 저장된 데이터 차트입니다." :to="'/s/' + pageSensor.id + '?mode=graph'">
      그래프
    </b-nav-item>

    <b-nav-item v-if="isLoginUserPageUser || isLoginUserAdmin" :active="current=='upload'" title="데이터를 업로드합니다." :to="'/s/' + pageSensor.id + '?mode=upload'">
      업로드
    </b-nav-item>

    <!--// v-if="isLoginUserItemWritable(this.pageSensor) || isLoginUserAdmin" //-->

    <b-nav-item v-if="isLoginUserItemReadable(this.pageSensor)" :active="current=='download'" title="데이터를 다운로드합니다." :to="'/s/' + pageSensor.id + '?mode=download'">
      다운로드
    </b-nav-item>

    <div class="buttonBox mt-1">

      <slot></slot>

      <b-button v-if="!isLoginUserPageUser && !isIdLoginUserFriend(this.pageUser.id)" variant="secondary" size="sm" class="tabButton mr-2" @click="addFriend(pageUser)">
        친구 &plus;
      </b-button>

      <span v-else-if="!isLoginUserPageUser" class="m-1 mr-2 text-primary font-weight-bold tabText">
        <span v-if="isIdPageUserFriend(loginUser.id)">
          서로 친구
        </span>
        <span v-else>
          내 친구
        </span>
      </span>

      <span v-else class="m-1 mr-2 text-primary font-weight-bold tabText">
        나
      </span>

      <b-button v-if="!isLoginUserPageUser" @click="addBookmarkPageSensor" variant="secondary" size="sm" class="tabButton mr-2" v-b-tooltip.hover.left title="북마크에 추가하기">
        북마크 &plus;
      </b-button>


    </div>


  </b-nav>
</template>
<script>
import uiUtil from "@/mixins/util.js"
import user from "@/mixins/user.js"
export default {
  name: "sensorTabs",
  mixins: [uiUtil, user],
  props: {
    pageUser: {
      type: Object,
      default: null
    },
    pageDevice: {
      type: Object,
      default: null
    },
    pageSensor: {
      type: Object,
      default: null
    },
    current: {
      type: String,
      default: ""
    },
  },
  methods: {
    addBookmarkPageSensor: function() {
      this.addBookmark({
        "type": 30,
        "id": this.pageSensor.id,
        "name": this.pageSensor.name,
        "mode": this.current,
        "uid": this.pageUser.id,
        "uName": this.pageUser.displayName,
        "did": this.pageDevice.id,
        "dName": this.pageDevice.name,
      });
    },
  }
}
</script>
